/* eslint-disable consistent-return */
/* eslint-disable no-return-await */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "../../../utils/leadsWebEnviroment";

interface BodyProps {
  idLead: string | undefined;
  observacaoLead: string | undefined;
}

interface Params {
  idLeadCorretor: string | undefined;
  body: BodyProps;
}

export function useAlterarObservacao(props: Params) {
  const registerData = async () => {
    const ALTERAR_OBSERVACAO = `${leadsWebEnviroment}/commom/leads/alterar-observacao-lead/v1/${props?.idLeadCorretor}`;
    return await instance.put(ALTERAR_OBSERVACAO, props?.body);
  };
  const query = useMutation({
    mutationFn: async () => await registerData(),
    mutationKey: ["alterar_observacao"],
    onSuccess: () => {
      toast.success("A observação do lead foi alterada com sucesso", {
        autoClose: 10000,
      });
    },
    onError: (error: any) => {
      const errorMessages = error.response.data.notifications.map(
        (item: any) => `\n${item?.message}\n`
      );

      toast.error(errorMessages.join(""), { autoClose: 10000 });
    },
  });
  return query;
}
